import {
  AnalyticsEventBuilder,
  AnalyticsEventAction,
  AnalyticsEvent,
} from "./../AnalyticsEventBuilder";
import { Game } from "../../../models/Game";

export class GamesAnalyticsAi {
  gameStart(game: Game, isTheaterMode: boolean): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("funnelContentStart");
    event.setNonInteraction(false);
    event.setGame(game);
    event.setCustom("theatreModeOn", isTheaterMode);
    return event.build();
  }

  /**
   * @param game
   * @param duration in milliseconds
   * @param score
   */
  gameEnd(
    game: Game,
    duration: number,
    score: number,
    isTheaterMode: boolean
  ): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("funnelContentEnd");
    event.setNonInteraction(false);
    event.setGame(game);
    event.setCustom("eventDuration", duration / 1000);
    event.setCustom("score", score);
    event.setCustom("theatreModeOn", isTheaterMode);
    return event.build();
  }

  prerollStart(game: Game): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("funnelPrerollRequest");
    event.setNonInteraction(true);
    event.setGame(game);
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  /**
   * @param game
   * @param duration in milliseconds
   */
  prerollEnd(game: Game, duration: number): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("funnelPrerollEnd");
    event.setNonInteraction(true);
    event.setGame(game);
    event.setCustom("eventDuration", duration / 1000);
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  playAgainClick(game: Game): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("funnelEndButtonPlayAgain");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setGame(game);
    event.setCustom("theatreModeOn", false);
    return event.build();
  }

  gameEndShareClick(game: Game): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("shareButton");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setGame(game);
    return event.build();
  }

  gameEndEngagementPromoClick(game: Game): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("funnelEndButtonPromoUp");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setGame(game);
    return event.build();
  }

  gameEndCrossPromotionClick(game: Game): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("funnelEndButtonPromoLower");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setGame(game);
    return event.build();
  }

  performanceMeasure(game: Game, pe: PerformanceEntry): AnalyticsEvent {
    const event = this.newEventBuilder();
    event.setName("performanceMeasure");
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(true);
    event.setGame(game);
    event.setCustom("PerformanceEntryName", pe.name);
    event.setCustom("PerformanceEntryEntryType", pe.entryType);
    event.setCustom("PerformanceEntryDuration", pe.duration);
    event.setCustom("PerformanceEntryStartTime", pe.startTime);
    return event.build();
  }

  theaterModeClick(game: Game, isTheaterMode: boolean): AnalyticsEvent {
    const name = isTheaterMode ? "theatreMode" : "defaultMode";
    const event = this.newEventBuilder();
    event.setName(name);
    event.setEventAction(AnalyticsEventAction.CLICK);
    event.setNonInteraction(false);
    event.setGame(game);
    event.setCustom("theatreModeOn", isTheaterMode);
    return event.build();
  }

  private newEventBuilder(): AnalyticsEventBuilder {
    return new AnalyticsEventBuilder().baseEvent();
  }
}
